import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import { Route, Routes, useNavigate, Navigate } from 'react-router-dom'

import styles from './Content.module.css'

import PageHead, { PageHeading, PageHeadRight } from 'Layout/PageHead'
import PageContent from 'Layout/PageContent'
import PageTabs, { PageTabList, PageTab } from 'Layout/PageTabs'
import Button from 'Design/components/Button'

import Answers from './Answers'
import AnswersList from './Answers/AnswersList'
import CreateAnswer from './Answers/CreateAnswer'
import EditAnswer from './Answers/EditAnswer'
import Guides from './Guides'
import GuidesList from './Guides/GuidesList'
import CreateGuide from './Guides/CreateGuide'
import EditGuide from './Guides/EditGuide'
import KnowledgeBase from './KnowledgeBase'
import KBList from './KnowledgeBase/KBList'
import ImportKB from './KnowledgeBase/ImportKB'
import AddKbButton from './KnowledgeBase/AddKbButton'
import ReleaseNotes from './ReleaseNotes'
import ReleaseNotesList from './ReleaseNotes/ReleaseNotesList'
import CreateReleaseNote from './ReleaseNotes/CreateReleaseNote'
import EditReleaseNote from './ReleaseNotes/EditReleaseNote'

import { $getIsInternalFeatureSupported } from 'Selectors/account'

const NewContentCTA = ({ children }) => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate('create')
  }

  return (
    <Button variant='primary' onClick={handleClick}>
      {children}
    </Button>
  )
}

const Content = () => {
  const isInternalFeatureSupported = useSelector($getIsInternalFeatureSupported)

  return (
    <Fragment>
      <PageHead>
        <PageHeading>Content</PageHeading>
        <PageHeadRight>
          <Routes>
            <Route path='answers' element={<NewContentCTA>New Answer</NewContentCTA>} />
            <Route path='guides' element={<NewContentCTA>New Guide</NewContentCTA>} />
            <Route path='kbs' element={<AddKbButton />} />
            <Route path='release-notes' element={<NewContentCTA>New Release Note</NewContentCTA>} />
          </Routes>
        </PageHeadRight>
      </PageHead>

      <PageContent>
        <PageTabs>
          <PageTabList className={styles.ContentTabHead}>
            <PageTab to='answers' title='Answers' />
            <PageTab to='guides' title='Guides' />
            <PageTab to='kbs' title='Knowledge Base' />
            {isInternalFeatureSupported && <PageTab to='release-notes' title='Release Notes' />}
          </PageTabList>

          <Routes>
            <Route path='answers' element={<Answers />}>
              <Route index element={<AnswersList />} />
              <Route path='create' element={<CreateAnswer />} />
              <Route path=':id' element={<EditAnswer />} />
            </Route>

            <Route path='guides' element={<Guides />}>
              <Route index element={<GuidesList />} />
              <Route path='create' element={<CreateGuide />} />
              <Route path=':id' element={<EditGuide />} />
            </Route>

            <Route path='kbs' element={<KnowledgeBase />}>
              <Route index element={<KBList />} />
              <Route path='import' element={<ImportKB />} />
            </Route>

            {isInternalFeatureSupported && (
              <Route path='release-notes' element={<ReleaseNotes />} disabled>
                <Route index element={<ReleaseNotesList />} />
                <Route path='create' element={<CreateReleaseNote />} />
                <Route path=':id' element={<EditReleaseNote />} />
              </Route>
            )}

            <Route path='*' element={<Navigate to='answers' replace />} />
          </Routes>
        </PageTabs>
      </PageContent>
    </Fragment>
  )
}

export default Content
